import axios from 'lib/axios'
import type { GetDataHome } from '../store'

export const fetchHomeUserEvaluated = async (): Promise<GetDataHome[]> => {
  const response: GetDataHome[] = (await axios.get('exam/assigned_tests')).data.data
  return response
}

export const fetchInformedConsentUser = async (id: string, acceptedConsent: boolean, answer_device: "DESKTOP" | "MOBILE") => {
  try {
    const response = await axios.put(`user_test/${id}`, { informed_consent: acceptedConsent, answer_device })
    return response.data
  } catch (error) {
    throw new Error('Error fetching get assignment tests')
  }
}

export const fetchUserConsented = async (id: string, isBetesaTest?: boolean) => {
  try {
    const response = await axios.get(`user_test/${id}${isBetesaTest ? `?is_betesa_test=${isBetesaTest}` : ''}`)
    return response.data
  } catch (error) {
    throw new Error('Error fetching get assignment tests')
  }
}
